import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsExpandLess = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="m7.4 15.375-1.4-1.4 6-6 6 6-1.4 1.4-4.6-4.6z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsExpandLess);
const Memo = memo(ForwardRef);
export default Memo;
